import Helper from './Helper';

class Dropdown {
	constructor(config = {}) {
		const {
			submenuTogglerSelector,
		} = config;

    this.submenuToggler = document.querySelectorAll(submenuTogglerSelector);
		this.togglerArray = Array.prototype.slice.call(this.submenuToggler);

		if(this.submenuToggler){
			this.bindEvents();
		}
  }

  bindEvents() {
    // console.log('bindEvents function');
    this.togglerArray.forEach(toggler =>
      toggler.addEventListener('click', e => {
        this.toggleSubmenu(toggler, e);
      })
    );
	}

  toggleSubmenu(toggler, e) {
		Helper.toggleClass(toggler, 'open');
    Helper.slideToggle(toggler.nextElementSibling, 200);
  }
}

export default Dropdown;
